import { Box } from '../../primitives';
import { styled } from '../../theme';

export const Wrapper = styled(Box)``;
